import { render, staticRenderFns } from "./FundingProjectsFilter.vue?vue&type=template&id=2c8dded8&"
import script from "./FundingProjectsFilter.vue?vue&type=script&lang=ts&"
export * from "./FundingProjectsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports